if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      console.log('hello');
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          this.handleAddedState();
        });
    }


    handleAddedState() {
      const submitButtonAdded = this.submitButton.querySelector('.product-form__added');

      if (submitButtonAdded) {
        submitButtonAdded.classList.remove('hidden');

        setTimeout(() => {
          submitButtonAdded.classList.add('hidden');
        }, 1000);

        this.showRecommendedSection();
      };
    }

    showRecommendedSection() {
      const recommendedContainer = document.querySelector('.recommended');
      const recommendedItems = document.querySelectorAll('product-recommendations li');

      if (recommendedContainer && recommendedItems.length) {
        const pageHeader = document.querySelector('.section-header.shopify-section-group-header-group');
        const pageBar = document.querySelector('.announcement-bar-section');
        const trustpilotWidget = document.querySelector('.trustpilot-widget');

        recommendedContainer.classList.add('visible');
        pageHeader.style.zIndex = 11
        pageBar.style.zIndex = 11

        if (trustpilotWidget) {
          trustpilotWidget.style.zIndex = 7
        };

        this.calculateHeaderHeight(recommendedContainer);
        this.closeRecommendedSection(recommendedContainer, pageHeader, pageBar)
        document.body.classList.add('overflow-hidden');
        document.documentElement.scrollTop = 0;
      };
    }

    closeRecommendedSection(container, header, topBar) {
      const closeTriggers = document.querySelectorAll('.js-close-recommended');
      header.style.zIndex = 11

      closeTriggers.forEach(closeTrigger => {
        closeTrigger.addEventListener('click', (event) => {
          event.preventDefault();

          container.classList.remove('visible');
          document.body.classList.remove('overflow-hidden');
          header.removeAttribute('style');
          topBar.removeAttribute('style');
        });
      });
    }

    calculateHeaderHeight(container) {
      let headerHeight = 0;
      let sectionHeaderHeight = 0;
      let announcementBarSectionHeight = 0;

      const sectionHeader = document.querySelector('.section-header');
      const announcementBarSection = document.querySelector('.announcement-bar-section');

      if (sectionHeader) {
        sectionHeaderHeight = sectionHeader.offsetHeight;
      };

      if (announcementBarSection) {
        announcementBarSectionHeight = announcementBarSection.offsetHeight;
      };

      headerHeight = sectionHeaderHeight + announcementBarSectionHeight;

      if (container) {
        container.querySelector('.recommended__inner').style.paddingTop = (headerHeight + 40) + 'px'
        // container.querySelector('.recommended__inner').style.paddingTop
      };
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
  });
}
